/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Who initiated the cancellation
 */
export enum CancelledBy {
  user = 'user',
  professional = 'professional',
  admin = 'admin',
  system = 'system'
}
